/* prettier-ignore */

import { Injectable, signal } from '@angular/core';
import { Message } from '../interface/message.interface';
import { ChatStyles } from '../interface/chatStyles.interface';
import { generateToken } from '../helpers/helpers';

@Injectable({ providedIn: 'root' })
export class DataChatService {
  public name = signal<string>('ChatBot');
  public chatbaseId = signal<string>('');
  public id = signal('');
  public lang = signal('es');
  public messages = signal<Message[]>([]);
  public icon = signal<string | undefined>('');
  public logo = signal<string | undefined>('');
  public messagesForAzure = signal<Message[]>([]);
  public messagesForChatBase = signal<Message[]>([]);
  public recommendedMessages = signal<string[]>([]);
  public azureSystemPrompt = signal<string>('');
  public token = signal<string | undefined>('');
  public hasToken = signal(false);
  public requestIsFulliled = signal(false);
  public isAzure = signal<boolean>(false);
  public isStreaming = signal<boolean>(false);
  public chatIsTyping = signal<boolean>(false);

  public isUserSpeaking = signal<boolean>(false);
  public microIsActive = signal<boolean>(false)
  public isFullScreen = signal<boolean>(false);

  public abortSignal = signal<AbortController>(new AbortController());
  public debug = signal<boolean>(false);
  public isOpenAi = signal<boolean>(false);
  public is35 = signal<boolean>(false);
  public isNew = signal<string | null>(null);

  public toggleFormVisibility = signal<boolean>(false);
  public toggleSuccessMessage = signal<boolean>(false);
  public toggleErrorMessage = signal<boolean>(false);
  public canSaveChat = signal<boolean>(false);
  public hasSaveChat = signal<boolean>(false);
  public hasHistory = signal<boolean>(false);
  public isSendingChat = signal<boolean>(false);
  public inputLeads = signal<string[] | null>(null);
  public infoMessage = signal<string | null>(null);

  public showTooltip = signal<boolean>(false);
  public tooltipMsg = signal<string | null>(null)
  public hideChat = signal<boolean>(true);
  public chatIcon = signal<string>('/assets/imgs/chatbot-avatar.png');

  public inputText = signal(null)
  public selectedImage = signal<File | null>(null);
  public imagePreviewUrl = signal<string | null>(null);

  // POI Sidebar Logic
  public poiList = signal<any[]>([]);
  public activePoiIndex = signal<number>(0);
  public isPoiSidebarOpen = signal<boolean>(false);

  public chatStyles: ChatStyles = {
    header_color: '',
    text_header_color: '',
    user_message_color: '',
    user_text_color: '',
    user_border_color: '',
    user_gradient_1: '',
    bot_message_color: '',
    bot_text_color: '',
    bot_border_color: '',
    bot_gradient_1: '',
    bot_gradient_2: '',
    background_color: '',
    button_color: '',
  };


  constructor() { }

  resetChat() {
    this.requestIsFulliled.set(false);
    this.messages.set([])
    this.token.set(generateToken());
  }

  removeErrorMsgs() {
    this.messages.update((prev) =>
      prev.filter((msg) => !msg.danger)
    );
  }
}
